<template>
  <div>
    <!-- 图片上传组件辅助-->
    <a-upload class="avatar-uploader" name="file" :customRequest="handleUpload" :showUploadList="false" listType="picture" :multiple="false" accept=".png,.jpeg,.jpg" :withCredentials='true'>
    </a-upload>

    <quill-editor :class="`editor ${height400}`" v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
    </quill-editor>

    <!-- 上传进度 -->
    <a-spin :tip="`上传中 ${fileData.progress}% ...`" :spinning="uploadImgStatus == 'uploading'&& quillUpdateImg">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
  </div>
</template>

<script>
// const img1 = require("../assets/image/student/unitTwo/translate.png");
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 必须要引入
import * as Quill from "quill";
// 自定义字号的大小，注意下面的内容要和css里面对应上
var sizes = [false, "10px", "12px", "14px", "16px", "18px", "20px", "22px", "26px", "28px", "30px"];
var Size = Quill.import("formats/size");
Size.whitelist = sizes;


// 实现quill-editor编辑器拖拽/粘贴图片，并在插入前提供 handler 钩子
// 使用 `quill-image-drop-and-paste`，该模块支持 handler 回调
import QuillImageDropAndPaste from "quill-image-drop-and-paste";
Quill.register("modules/imageDropAndPaste", QuillImageDropAndPaste);
//实现quill-editor编辑器调整图片尺寸
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageResize", ImageResize);

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  //["blockquote", "code-block"], // 引用  代码块
  //[{ header: 1 }, { header: 2 }], // 1、2 级标题
  // [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ 'direction': 'rtl' }],                         // 文本方向
  // [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ size: sizes }], // 配置字号
  // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  // [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image"] // 链接、图片、视频
];

import services from '../assets/js/services';
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    /*编辑器的内容*/
    valuetxt: {
      type: String
    },
    /*图片大小*/
    maxSize: {
      type: Number,
      default: 4000 //kb
    },
    imgLabel: {
      type: String,
      default: 'cases' // 图片上传label
    },
    height400: {
      type: String,
      default: ''
    }
  },

  components: {
    quillEditor
  },

  data() {
    return {
      content: this.valuetxt,
      services,
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      limitSize: 10 * 1024 * 1024, // 最大上传30MB
      limitText: "10MB",// 超出限制提示文本
      fileData: {
        progress: 0
      }, // 上传图片数据
      uploadImgStatus: '', // 图片上传状态
      editorOption: {
        theme: "snow", // or 'bubble'
        placeholder: "请输入内容",
        modules: {
          // 新增下面
          imageDropAndPaste: {
            handler: (imageDataUrl, type, imageData) => {
              console.log(1);
              
              let file = imageData.toFile()
              this.handleUpload({ file: file })
         
            },
          }, // 拖动/粘贴图片模块（带 handler）
          // imageDrop: true,
          imageResize: { //调整大小组件。
            displaySize: true,
            // displayStyles: {
            //     backgroundColor: 'black',
            //     border: 'none',
            //     color: 'white'
            // },
            // modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
          },

          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            handlers: {
              image: this.handlersImage,
              //   link: function(value) {
              //     if (value) {
              //       var href = prompt('请输入url');
              //       this.quill.format("link", href);
              //     } else {
              //       this.quill.format("link", false);
              //     }
              //   },
            }
          }
        }
      },
    };
  },
  watch: {
    valuetxt(newVal) {
      this.content = newVal
    },
  },
  mounted() {
    // 获取富文本组件实例
    // let myQuillEditor = this.$refs.myQuillEditor.quill;
    // window.addEventListener('paste', e => {
    //   let that = this
    //   console.log(e)
    //   if (e.clipboardData && e.clipboardData.files && e.clipboardData.files.length) {
    //     e.preventDefault(); // 阻止默认行为即不让剪贴板内容在div中显示出来
    //     // 获取图片内容
    //     const files = e.clipboardData.files;
    //     that.handleUpload({ file: files[0] })
    //   } else {
    //     console.log("粘贴内容不是图片");
    //   }
    // })
  },

  methods: {
    setupImageHandlers() {
      // 获取编辑器容器
      const editorContainer = this.$refs.myQuillEditor.$el.querySelector('.ql-container') ||
        this.$refs.myQuillEditor.$el;

      // 拖拽进入
      editorContainer.addEventListener('dragenter', (e) => {
        console.log('dragenter', e);
        e.preventDefault();
      });

      // 拖拽悬浮
      editorContainer.addEventListener('dragover', (e) => {
        console.log('dragover', e);
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
      });

      // 拖拽离开
      editorContainer.addEventListener('dragleave', (e) => {
        console.log('dragleave', e);
      });

      // 拖拽放下
      editorContainer.addEventListener('drop', (e) => {
        console.log('🎯 DROP 事件触发', e.dataTransfer.files);
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer.files;
        if (files.length > 0) {
          const imageFiles = Array.from(files).filter(file =>
            file.type.startsWith('image/')
          );

          if (imageFiles.length > 0) {
            console.log('📸 检测到图片文件:', imageFiles);
            this.handleDroppedImages(imageFiles);
          }
        }
      })
    },
    dataURLtoFile(dataurl, name) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], name, { type: mime })
    },
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
      this.$emit("inputChange", this.content);
    },
    // 自定义编辑器图片点击事件
    handlersImage(value) {
      if (value) {
        if (this.uploadImgStatus == 'uploading') {
          this.$message.info("请等待上传完成后再次上传")
        } else {
          // 触发input框选择图片文件
          document.querySelector(".avatar-uploader input").click();
        }
      } else {
        this.quill.format("image", false);
      }
    },
    // upload图片自定义上传方法
    handleUpload({ file }) {
      let that = this
      if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的文件`)
      that.uploadImgStatus = 'uploading'
      that.quillUpdateImg = true
      that.fileData = {
        filename: file.name, // 附件名称
        progress: 0, // 上传进度
        view_url: URL.createObjectURL(file),
        path: ''
      }

      const chunkSize = 1024 * 1024 * 3; // 3MB
      const totalChunks = Math.ceil(file.size / chunkSize); // 计算文件总片数
      const uuid = uuidv4() // 文件唯一标识
      let currentChunk = 0; // 当前上传的分片索引
      let uploadedBytes = 0; // 已上传的总字节数

      function uploadChunk() {
        const start = currentChunk * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const data = file.slice(start, end);
        const formData = new FormData();
        formData.append("file", data, file.name);
        formData.append("label", that.imgLabel);
        formData.append("is_tmp", "1");
        formData.append("uuid", uuid);
        formData.append("chunks", totalChunks);
        formData.append("chunk", currentChunk);
        // 发送分片数据
        axios.post(`${services.HOST}/api/upload/file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const chunkUploadedBytes = progressEvent.loaded;
            uploadedBytes = currentChunk * chunkSize + chunkUploadedBytes;
            // 更新上传进度
            let percent = Math.round((uploadedBytes / file.size) * 100);
            if (percent > that.fileData.progress) {
              that.fileData.progress = percent > 100 ? 100 : percent;
            }
          }
        }).then(({ data: result }) => {
          if (currentChunk < totalChunks - 1) {
            // 继续上传下一片
            currentChunk++;
            uploadChunk();
          } else {
            that.quillUpdateImg = false
            if (result.code == "0000") {
              that.uploadImgStatus = 'success'
              that.$set(that.fileData, 'progress', 100)
              that.$set(that.fileData, 'view_url', result.data.url)
              that.$set(that.fileData, 'path', result.data.path)

              // 获取富文本组件实例
              let quill = that.$refs.myQuillEditor.quill;
              // 获取光标所在位置
              let length = quill.getSelection().index;
              // 插入图片  res.url为服务器返回的图片地址
              quill.insertEmbed(length, "image", result.data.url);
              // 调整光标到最后
              quill.setSelection(length + 1);
            } else {
              that.$message.error("图片插入失败")
              that.fileData = null
              that.uploadImgStatus = 'error'
            }

          }
        }).catch((error) => {
          that.quillUpdateImg = false
          that.uploadImgStatus = 'error'
          console.error("上传失败", error);
        });
      }

      // 开始上传第一片
      uploadChunk();
    },
  }
};
  </script>
 
  <style>
.editor {
  line-height: normal !important;
  height: 600px;
  padding-bottom: 10px;
  white-space: pre-wrap;
  margin-top: -10px;
}
.editor.height400 {
  height: 400px;
}
.ql-container.ql-snow {
  height: calc(100% - 66px);
  overflow: hidden !important;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}
.ql-snow .ql-tooltip::before {
  content: "访问链接:";
}
.ql-snow .ql-tooltip a.ql-action::after {
  content: "编辑";
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: "删除";
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}
/* 默认字号 */
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px";
  font-size: 10px;
}

.ql-size-10px {
  font-size: 10px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px";
  font-size: 12px;
}

.ql-size-12px {
  font-size: 12px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
  font-size: 14px;
}

.ql-size-14px {
  font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
  font-size: 16px;
}

.ql-size-16px {
  font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
  font-size: 18px;
}

.ql-size-18px {
  font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px";
  font-size: 20px;
}

.ql-size-20px {
  font-size: 20px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22px";
  font-size: 22px;
}

.ql-size-22px {
  font-size: 22px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26px";
  font-size: 26px;
}

.ql-size-26px {
  font-size: 26px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28px";
  font-size: 28px;
}

.ql-size-28px {
  font-size: 28px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30px";
  font-size: 30px;
}

.ql-size-30px {
  font-size: 30px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>